export default {
  category: 'book',
  name: 'The Coddling of the American Mind',
  author: 'Greg Lukianoff',
  date: '3/10/25',
  path: '/notes/the-coddling-of-the-american-mind',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-the-coddling-of-the-american-mind-greg-lukianoff.jpg',
  tags: ['Psychology', 'Education', 'Parenting'],
  time: 48,
  rating: 5.5,
  review: '',
  link: 'https://www.amazon.com/Coddling-American-Mind-Intentions-Generation/dp/0735224897',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
  twosLink: 'https://www.twosapp.com/67a8a63ca8aab5836f7f1359',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
